<div
  class="card stat-block stat-block--health-status"
  [ngClass]="isLoading ? 'skeleton-loader' : 'loaded'">
  <div class="card-body">
    <div class="card-title mb-4">
      <div class="row mb-3 align-items-center">
        <div class="col-auto">
          <div
            class="icon-rounded small-icon bg-secondary text-white"
            [ngClass]="{ 'loading': isLoading }">
            <i class="iconoir-graph-up"></i>
          </div>
        </div>
        <div class="col text-secondary">
          <span [ngClass]="{ 'loading': isLoading }">Health status</span>
        </div>
      </div>
    </div>
    <div class="row flex-nowrap">
      <div class="col-5 col-lg-6">
        <div class="h6 text-muted">
          <span [ngClass]="{ 'loading': isLoading }">Transactions</span>
        </div>
        <div class="row flex-nowrap mb-4">
          <div class="col-auto">
            <div
              class="stat-icon"
              [ngClass]="{ 'loading': isLoading }">
              <i class="iconoir-cart"></i>
            </div>
          </div>
          <div
            id="transactionsCount"
            class="col-auto stat-lg color-block blue"
            [ngClass]="{ 'loading min-w-100': isLoading }">
            {{ transactionsWidgetData?.transactions }}
          </div>
        </div>
        <div class="h6 text-muted">
          <span [ngClass]="{ 'loading': isLoading }">Receipts not captured</span>
        </div>
        <div class="row flex-nowrap mb-4">
          <div class="col-auto">
            <div
              class="stat-icon"
              [ngClass]="{ 'loading': isLoading }">
              <i class="pays-icon ic-receipt"></i>
            </div>
          </div>
          <div
            id="noReceiptCount"
            class="col-auto stat-lg color-block dark"
            [ngClass]="{ 'loading min-w-100': isLoading }">
            {{ transactionsWidgetData?.no_receipt }}
          </div>
        </div>
      </div>
      <div class="col-7 col-lg-6 app-circle-graph-wrapper">
        @if (isLoading) {
          <div class="circle-chart-128"></div>
        } @else {
          <div
            id="healthPercentage"
            class="invisible">
            {{ healthPercentage() }}
          </div>
          <app-circle-graph [data]="healthPercentage()"></app-circle-graph>
        }
      </div>
    </div>
    <div class="text-end mt-3">
      <button
        class="btn btn-primary btn-sm"
        (click)="sendReminders()"
        [disabled]="isSending || limitReached || transactionsWidgetData?.no_receipt === 0">
        @if (isSending) {
          Sending...
          <div
            class="spinner-border spinner-border-sm m-0"
            aria-label="Loading"></div>
        } @else {
          Send reminders
        }
      </button>
    </div>
  </div>
</div>
